import handleResponse from './request/handleResponse'

export default function fetchFacilities(api: GlobalFetch) {
  return async function() {
    const buildUrl = `/api/v2/amentity/list`
    const response = await api.fetch(buildUrl)

    return await handleResponse(response)
  }
}

export interface IData {
  messages: string[]
  items: { [key: string]: IItemData[] }
}

export interface IItemData {
  category: string
  created_at: string
  deleted: string
  id: string
  name: string
  updated_at: string
}
